import EnvironmentConfig from '../interfaces/EnvironmentConfig';

const saravanaConfig: EnvironmentConfig = {
  surveyJsKey: 'YjMyZTEzNTYtMGEwNi00NGNlLTkxMWQtY2NhNjhkOGQ1NGUyOzE9MjAyNi0wMy0yMiwyPTIwMjYtMDMtMjIsND0yMDI2LTAzLTIy',

  dashboardClassic: 'https://classic.crm.supersaravanastores.com',
  ruleServerUrl: 'https://classic.api.crm.supersaravanastores.com',
  apiServerUrl: 'https://api.crm.supersaravanastores.com',
  casaWebAppUrl: 'https://web.crm.supersaravanastores.com',
  commerceConnect: 'https://commerce-connect-up.crm.supersaravanastores.com',
  pwaUrl: 'qa.casarewards.com',
  dashboard: 'https://crm.supersaravanastores.com',
  ruleUIUrl: 'https://rule.crm.supersaravanastores.com',
  ticketDeskUrl: '',
  ingressUrl: '',
  keycloakConfig: {
    url: `https://auth.crm.supersaravanastores.com`,
    realm: `casa`,
    clientId: `casa_dashboard`,
  },
  socialMedia: {
    facebook: {
      appId: 'appId',
    },
    googleAds: {
      clientId: "273230167843-mdnnlq3creq5jouop3kfbvsjg2mqmpl6.apps.googleusercontent.com",
      redirectURI: "https://crm.supersaravanastores.com/settings/integrations/social-media",
    },
  },
};

export default saravanaConfig;
